import { PageTitle } from "@/components/page-title";
import { BankStatementForm } from "./_form";

function BankStatementNew() {
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <PageTitle>New bank statement</PageTitle>
      <BankStatementForm />
    </div>
  );
}

export default BankStatementNew;
